


































import Tab from '@/pantallas/ReportesSerie/components/Tab.vue';
import Tabs from '@/pantallas/ReportesSerie/components/Tabs.vue';
import SimNumeroFormGeneral from './SimNumeroFormGeneral.vue';
import EquipoActivoForm from './EquipoActivoForm.vue';
import SimMovimientosForm from './SimMovimientosForm.vue';
import SimDesactivadoresForm from './SimDesactivadoresForm.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    Tab,
    Tabs,
    SimNumeroFormGeneral,
    EquipoActivoForm,
    SimMovimientosForm,
    SimDesactivadoresForm,
  },
})
export default class InventarioSimForm extends Vue {
  @Prop({ default: null }) serieNumeroSeleccionado: any;
  @Prop({ default: null }) tipoEquipoSeleccionado: any;
  @Prop({ default: null }) simestadolistSeleccionado: any;
}
